import { useTranslation } from 'react-i18next'

import usePageModal from 'features/Modal/hooks/usePageModal'
import { useRemoveRelatedGroupsMutation } from 'store/api/yay/group'
import { Link } from 'features/i18n/router'
import { MODAL_MODE } from '../config'
import { useSearchRelatedGroups } from './useSearchRelatedGroups'
import { useGroupUserRole } from 'pages/Group/hooks/useGroupUserRole'

import GroupList from 'components/GroupList'

import './style.scss'

const RelatedGroupsModal = ({ location, groupId }) => {
  const { t } = useTranslation()
  const { generatePageModalUrl } = usePageModal()
  const [removeRelatedGroup] = useRemoveRelatedGroupsMutation()

  const groupUserRole = useGroupUserRole({ groupId })

  const { isEmptyList, relatedGroups, onLoadMore, searchText, setSearchText } =
    useSearchRelatedGroups({ groupId })

  return (
    <div className="Modal__wrapper RelatedGroupsModal">
      <div className="Modal__header">
        <Link className="Modal__header__close" to={location.pathname} />

        <h2 className="Modal__header__h2">{t('related_groups_modal.title')}</h2>

        {(groupUserRole == 'moderator' || groupUserRole == 'owner') && (
          <div className="Modal__header__right">
            <Link
              to={generatePageModalUrl(MODAL_MODE.ADD_RELATED_GROUPS, {
                groupId,
              })}
              className="Button Button--green Button--icon-plus"
            >
              {t('common.add')}
            </Link>
          </div>
        )}
      </div>

      <div className="Modal__search">
        <div className="Search">
          <input
            className="Search__input"
            placeholder={t('related_groups_modal.search_placeholder')}
            type="text"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>
      </div>

      <div className="Modal__body">
        {isEmptyList ? (
          <div className="RelatedGroupsModal__empty">
            <b>{t('related_groups_modal.empty.title')}</b>
            <p>{t('related_groups_modal.empty.subtitle')}</p>
          </div>
        ) : (
          <GroupList
            groups={relatedGroups}
            onLoadMore={onLoadMore}
            controlMenu={(groupItem: any, menu: any) => {
              return [
                ...menu.filter(({ key }) => key !== 'delete'),
                ...(groupUserRole == 'moderator' || groupUserRole == 'owner'
                  ? [
                      {
                        key: 'removeRelatedGroup',
                        title: t(
                          'group_list.group_tools.menu.remove_related_group'
                        ),
                        onClick: () => {
                          removeRelatedGroup({
                            groupId,
                            relatedGroupId: groupItem.id,
                          })
                        },
                      },
                    ]
                  : []),
              ]
            }}
            descriptionMaxLine={2}
          />
        )}
      </div>
    </div>
  )
}

export default RelatedGroupsModal
